import { Union, Record } from "./.fable/fable-library.3.1.4/Types.js";
import { union_type, option_type, class_type, record_type, list_type, int32_type, bool_type, string_type } from "./.fable/fable-library.3.1.4/Reflection.js";

export class Autor$0027 extends Record {
    constructor(Name, Nachname, Vorname, Vortragender, FirmenIndex) {
        super();
        this.Name = Name;
        this.Nachname = Nachname;
        this.Vorname = Vorname;
        this.Vortragender = Vortragender;
        this.FirmenIndex = FirmenIndex;
    }
}

export function Autor$0027$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Autor\u0027", [], Autor$0027, () => [["Name", string_type], ["Nachname", string_type], ["Vorname", string_type], ["Vortragender", bool_type], ["FirmenIndex", list_type(int32_type)]]);
}

export class Firma$0027 extends Record {
    constructor(Name, Land) {
        super();
        this.Name = Name;
        this.Land = Land;
    }
}

export function Firma$0027$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Firma\u0027", [], Firma$0027, () => [["Name", string_type], ["Land", string_type]]);
}

export class Sitzungsleiter$0027 extends Record {
    constructor(AnzeigeName, Vorname, Nachname) {
        super();
        this.AnzeigeName = AnzeigeName;
        this.Vorname = Vorname;
        this.Nachname = Nachname;
    }
}

export function Sitzungsleiter$0027$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Sitzungsleiter\u0027", [], Sitzungsleiter$0027, () => [["AnzeigeName", string_type], ["Vorname", string_type], ["Nachname", string_type]]);
}

export class Raum$0027 extends Record {
    constructor(Id, Raum) {
        super();
        this.Id = Id;
        this.Raum = Raum;
    }
}

export function Raum$0027$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Raum\u0027", [], Raum$0027, () => [["Id", class_type("System.Guid")], ["Raum", string_type]]);
}

export class Beitrag$0027 extends Record {
    constructor(Id, Uhrzeit, Zeiten, SessionNr, Dauer, Vortragsnummer, Kurzfassung, Titel, Autoren, Firmen, Abgesagt) {
        super();
        this.Id = Id;
        this.Uhrzeit = Uhrzeit;
        this.Zeiten = Zeiten;
        this.SessionNr = SessionNr;
        this.Dauer = (Dauer | 0);
        this.Vortragsnummer = Vortragsnummer;
        this.Kurzfassung = Kurzfassung;
        this.Titel = Titel;
        this.Autoren = Autoren;
        this.Firmen = Firmen;
        this.Abgesagt = Abgesagt;
    }
}

export function Beitrag$0027$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Beitrag\u0027", [], Beitrag$0027, () => [["Id", string_type], ["Uhrzeit", string_type], ["Zeiten", list_type(string_type)], ["SessionNr", option_type(string_type)], ["Dauer", int32_type], ["Vortragsnummer", string_type], ["Kurzfassung", string_type], ["Titel", string_type], ["Autoren", list_type(Autor$0027$reflection())], ["Firmen", list_type(Firma$0027$reflection())], ["Abgesagt", bool_type]]);
}

export class Session$0027 extends Record {
    constructor(Id, Bezeichnung, Beschreibung, K$00FCrzel, Vortragsk$00FCrzel, Startzeit, Startzeiten, Sitzungsleiter, AndererRaum) {
        super();
        this.Id = Id;
        this.Bezeichnung = Bezeichnung;
        this.Beschreibung = Beschreibung;
        this["Kürzel"] = K$00FCrzel;
        this["Vortragskürzel"] = Vortragsk$00FCrzel;
        this.Startzeit = Startzeit;
        this.Startzeiten = Startzeiten;
        this.Sitzungsleiter = Sitzungsleiter;
        this.AndererRaum = AndererRaum;
    }
}

export function Session$0027$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Session\u0027", [], Session$0027, () => [["Id", class_type("System.Guid")], ["Bezeichnung", string_type], ["Beschreibung", string_type], ["Kürzel", option_type(string_type)], ["Vortragskürzel", string_type], ["Startzeit", string_type], ["Startzeiten", list_type(string_type)], ["Sitzungsleiter", list_type(Sitzungsleiter$0027$reflection())], ["AndererRaum", option_type(string_type)]]);
}

export class Programm$0027 extends Record {
    constructor(Startzeit, Startzeiten, K$00FCrzel, Beschreibung, Bezeichnung, AndererRaum) {
        super();
        this.Startzeit = Startzeit;
        this.Startzeiten = Startzeiten;
        this["Kürzel"] = K$00FCrzel;
        this.Beschreibung = Beschreibung;
        this.Bezeichnung = Bezeichnung;
        this.AndererRaum = AndererRaum;
    }
}

export function Programm$0027$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Programm\u0027", [], Programm$0027, () => [["Startzeit", string_type], ["Startzeiten", list_type(string_type)], ["Kürzel", option_type(string_type)], ["Beschreibung", string_type], ["Bezeichnung", string_type], ["AndererRaum", option_type(string_type)]]);
}

export class Termin extends Record {
    constructor(Id, SessionId, Name, Start, End, Description, Location, Url, WriteProtected) {
        super();
        this.Id = Id;
        this.SessionId = SessionId;
        this.Name = Name;
        this.Start = Start;
        this.End = End;
        this.Description = Description;
        this.Location = Location;
        this.Url = Url;
        this.WriteProtected = WriteProtected;
    }
}

export function Termin$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Termin", [], Termin, () => [["Id", string_type], ["SessionId", string_type], ["Name", string_type], ["Start", string_type], ["End", string_type], ["Description", string_type], ["Location", string_type], ["Url", string_type], ["WriteProtected", bool_type]]);
}

export class Rahmenprogramm$0027 extends Record {
    constructor(Zeit, Startdatum, Enddatum, Beschreibung, Bezeichnung, Raum) {
        super();
        this.Zeit = Zeit;
        this.Startdatum = Startdatum;
        this.Enddatum = Enddatum;
        this.Beschreibung = Beschreibung;
        this.Bezeichnung = Bezeichnung;
        this.Raum = Raum;
    }
}

export function Rahmenprogramm$0027$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Rahmenprogramm\u0027", [], Rahmenprogramm$0027, () => [["Zeit", string_type], ["Startdatum", string_type], ["Enddatum", string_type], ["Beschreibung", string_type], ["Bezeichnung", string_type], ["Raum", string_type]]);
}

export class Programmpunkt$0027 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Programm", "Session"];
    }
}

export function Programmpunkt$0027$reflection() {
    return union_type("TagungsProgramm.Shared.Domain.Programmpunkt\u0027", [], Programmpunkt$0027, () => [[["Item", Programm$0027$reflection()]], [["Item", Session$0027$reflection()]]]);
}

export class Achse$0027 extends Record {
    constructor(Startzeit, Datum, Pause, Programmpunkte) {
        super();
        this.Startzeit = Startzeit;
        this.Datum = Datum;
        this.Pause = Pause;
        this.Programmpunkte = Programmpunkte;
    }
}

export function Achse$0027$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Achse\u0027", [], Achse$0027, () => [["Startzeit", string_type], ["Datum", string_type], ["Pause", option_type(string_type)], ["Programmpunkte", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [class_type("System.Guid"), Programmpunkt$0027$reflection()])]]);
}

export class Tag$0027 extends Record {
    constructor(Datum, Wochentag, R$00E4ume, Achsen) {
        super();
        this.Datum = Datum;
        this.Wochentag = (Wochentag | 0);
        this["Räume"] = R$00E4ume;
        this.Achsen = Achsen;
    }
}

export function Tag$0027$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Tag\u0027", [], Tag$0027, () => [["Datum", string_type], ["Wochentag", int32_type], ["Räume", list_type(Raum$0027$reflection())], ["Achsen", list_type(Achse$0027$reflection())]]);
}

export class Klassifizierung$0027 extends Record {
    constructor(Id, Bezeichnung) {
        super();
        this.Id = Id;
        this.Bezeichnung = Bezeichnung;
    }
}

export function Klassifizierung$0027$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Klassifizierung\u0027", [], Klassifizierung$0027, () => [["Id", class_type("System.Guid")], ["Bezeichnung", string_type]]);
}

export class ManuskriptArt extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Manuskript", "Folien", "Poster"];
    }
}

export function ManuskriptArt$reflection() {
    return union_type("TagungsProgramm.Shared.Domain.ManuskriptArt", [], ManuskriptArt, () => [[], [], []]);
}

export class Manuskript extends Record {
    constructor(Pnr, Url, Art) {
        super();
        this.Pnr = Pnr;
        this.Url = Url;
        this.Art = Art;
    }
}

export function Manuskript$reflection() {
    return record_type("TagungsProgramm.Shared.Domain.Manuskript", [], Manuskript, () => [["Pnr", string_type], ["Url", string_type], ["Art", ManuskriptArt$reflection()]]);
}

